module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAYElEQVQYlXWN2w2AQAgEsQjswv6/fNRgtAqLGLN6JifckfDB7kwwYAJWYASss+o2sTpm3jk6krKzMIsCB/aOVMNi/CtaUoLF1q+jlOAoRCnBLaGWEqwdHiuPl+j6VWZ2A3dOHLbsnL3hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/Header/img/top_more.png
// module id = THBG
// module chunks = 42